<template>
  <div class="targetedPopulation">
    <div class="targetedPopulation_titleArea">
      <div class="title_left">
        <h3 class="title">
          定向人群
        </h3>
        <span class="text">选择合适的人群投放广告，同一定向内取并集，不同定向间取交集</span>
      </div>
      <div class="title_right">
        <button class="button"><i class="el-icon-data-line" /><span class="text">导入常用定向</span></button>
        <button class="button"><i class="el-icon-data-board" /><span class="text">保存该定向</span></button>
      </div>
    </div>
    <div class="targetedPopulation_main">
      <div class="main_item">
        <div class="item_title">
          <span class="title">地域</span>
        </div>
        <div class="item_main">
          <div class="mian_box">
            <el-radio
              v-model="obj.changregion"
              label="area"
              @change="changeone"
            >常驻地</el-radio>
            <el-radio
              v-model="obj.changregion"
              label="travel_area"
              @change="changeone"
            >差旅出行</el-radio>
          </div>
          <!-- <el-cascader
            placeholder="试试搜索：指南"
            size="small"
            :options="options"
            :props="{ multiple: true }"
            filterable
          /> -->
          <!-- <div class="inputboxr">
            <div @click="addressInputclick">
              <el-input v-model="addressInput" class="inputbox" placeholder="请输入内容" />
            </div>

            <div v-show="searchadress" class="searchboxcss">
              <el-tree
                ref="tree"
                :data="data"
                show-checkbox
                node-key="id"
                highlight-current
                :props="defaultProps"
                :check-on-click-node="true"
                @check="handleCheckChange"
                @node-click="handleNodeClick"
                @current-change="sopew"
              />
            </div>
          </div> -->
          <el-cascader
            ref="owner"
            v-model="obj.positionSelectValue"
            :options="provinceSelectDataList"
            :props="{value: 'id', label: 'name', children: 'city', multiple: true}"
            collapse-tags
            clearable
            @change="handle"
          />

        </div>
      </div>
      <div class="main_item">
        <div class="item_title">
          <span class="title">年龄</span>
        </div>
        <div class="item_main">
          <el-select
            v-model="obj.startAgeitem"
            placeholder="请选年龄"
            @change="startChange"
          >
            <el-option
              v-for="item in ageOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          -
          <el-select
            v-model="obj.endAgeitem"
            placeholder="请选年龄"
            @change="endChange"
          >
            <el-option
              v-for="item in ageOptions1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </div>
      <div class="main_item">
        <div class="item_title">
          <span class="title">性别</span>
        </div>
        <div class="item_main">
          <el-radio
            v-model="obj.allgender"
            label="1"
            @change="menAndWomen"
          >全选</el-radio>
          <el-radio
            v-model="obj.allgender"
            label="MALE"
            @change="menAndWomen"
          >男</el-radio>
          <el-radio
            v-model="obj.allgender"
            label="FEMALE"
            @change="menAndWomen"
          >女</el-radio>
        </div>
      </div>
      <div v-show="optionsbox">
        <div class="choose_box">
          <span class="title_box">学历</span>
          <el-radio-group v-model="educationradio" @change="educallmethod">
            <el-radio :label="1">全部</el-radio>
            <el-radio :label="2">自定义</el-radio>
          </el-radio-group>
          <div class="group_box">
            <el-checkbox-group
              v-show="educationradio === 2"
              v-model="checkedCities"
              @change="educationchange"
            >
              <el-checkbox v-for="educationitem in educationarr" :key="educationitem.id" :label="educationitem.id">{{ educationitem.name }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="choose_box">
          <span class="title_box">操作系统</span>
          <el-radio-group v-model="systemradio" @change="systemmethod">
            <el-radio :label="1">全部</el-radio>
            <el-radio :label="2">自定义</el-radio>
          </el-radio-group>
          <div class="group_box">
            <el-checkbox-group
              v-show="systemradio === 2"
              v-model="checkedsystem"
              @change="systemchange"
            >
              <el-checkbox v-for=" systemitem in systemarr" :key="systemitem.id" :label="systemitem.id">{{ systemitem.name }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="choose_box">
          <span class="title_box">手机价格</span>
          <el-radio-group v-model="phonepriceradio" @change="phonepricemethod">
            <el-radio :label="1">全部</el-radio>
            <el-radio :label="2">自定义</el-radio>
          </el-radio-group>
          <div class="group_box">
            <el-checkbox-group
              v-show="phonepriceradio === 2"
              v-model="checkedphoneprice"
              @change="phonepricechange"
            >
              <el-checkbox v-for="phonepriceitem in phonepricearr" :key="phonepriceitem.id" :label="phonepriceitem.id">{{ phonepriceitem.name }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <!-- <div v-if="!optionsbox" class="arrow_text" @click="optionsbox = true">
        更多人群信息
        <i class="arrow" />
      </div> -->
      <div v-if="optionsbox" class="arrow_text" @click="optionsbox = false">
        收起人群信息
        <i class="arrow two" />
      </div>
    </div>
  </div>
</template>

<script>
import { getProvincialurbanareas } from '@/api/legacyPlan.js'
import { directionList } from '@/api/customer/accountList/direction.js'
export default {
  props: {
    region1: {},
    gender1: {},
    startAge1: {},
    endAge1: {},
    education: {
      type: Array
    },
    user_os: {
      type: Array
    },
    device_price: {
      type: Array
    },
    ad_target: {}
  },
  data() {
    return {
      props: { multiple: true },
      provinceSelectDataList: [], // 省市地区选择列表
      addressInput: '', // 定向人群搜索框
      searchadress: false,
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      data: [],
      gender: '',
      ageOptions: [
        { value: 14, label: 14 },
        { value: 18, label: 18 },
        { value: 19, label: 19 },
        { value: 20, label: 20 },
        { value: 21, label: 21 },
        { value: 22, label: 22 },
        { value: 23, label: 23 },
        { value: 24, label: 24 },
        { value: 25, label: 25 },
        { value: 26, label: 26 },
        { value: 27, label: 27 },
        { value: 28, label: 28 },
        { value: 29, label: 29 },
        { value: 30, label: 30 },
        { value: 31, label: 31 },
        { value: 32, label: 32 },
        { value: 33, label: 33 },
        { value: 34, label: 34 },
        { value: 35, label: 35 },
        { value: 36, label: 36 },
        { value: 37, label: 37 },
        { value: 38, label: 38 },
        { value: 39, label: 39 },
        { value: 40, label: 40 },
        { value: 41, label: 41 },
        { value: 42, label: 42 },
        { value: 43, label: 43 },
        { value: 44, label: 44 },
        { value: 45, label: 45 },
        { value: 46, label: 46 },
        { value: 47, label: 47 },
        { value: 48, label: 48 },
        { value: 49, label: 49 },
        { value: 50, label: 50 },
        { value: 51, label: 51 },
        { value: 52, label: 52 },
        { value: 53, label: 53 },
        { value: 54, label: 54 },
        { value: 55, label: 55 },
        { value: 56, label: 56 },
        { value: 57, label: 57 },
        { value: 58, label: 58 },
        { value: 59, label: 59 },
        { value: 60, label: 60 },
        { value: 61, label: 61 },
        { value: 62, label: 62 },
        { value: 63, label: 63 },
        { value: 64, label: 64 },
        { value: 65, label: 65 }
      ],
      ageOptions1: [
        { value: 14, label: 14 },
        { value: 18, label: 18 },
        { value: 19, label: 19 },
        { value: 20, label: 20 },
        { value: 21, label: 21 },
        { value: 22, label: 22 },
        { value: 23, label: 23 },
        { value: 24, label: 24 },
        { value: 25, label: 25 },
        { value: 26, label: 26 },
        { value: 27, label: 27 },
        { value: 28, label: 28 },
        { value: 29, label: 29 },
        { value: 30, label: 30 },
        { value: 31, label: 31 },
        { value: 32, label: 32 },
        { value: 33, label: 33 },
        { value: 34, label: 34 },
        { value: 35, label: 35 },
        { value: 36, label: 36 },
        { value: 37, label: 37 },
        { value: 38, label: 38 },
        { value: 39, label: 39 },
        { value: 40, label: 40 },
        { value: 41, label: 41 },
        { value: 42, label: 42 },
        { value: 43, label: 43 },
        { value: 44, label: 44 },
        { value: 45, label: 45 },
        { value: 46, label: 46 },
        { value: 47, label: 47 },
        { value: 48, label: 48 },
        { value: 49, label: 49 },
        { value: 50, label: 50 },
        { value: 51, label: 51 },
        { value: 52, label: 52 },
        { value: 53, label: 53 },
        { value: 54, label: 54 },
        { value: 55, label: 55 },
        { value: 56, label: 56 },
        { value: 57, label: 57 },
        { value: 58, label: 58 },
        { value: 59, label: 59 },
        { value: 60, label: 60 },
        { value: 61, label: 61 },
        { value: 62, label: 62 },
        { value: 63, label: 63 },
        { value: 64, label: 64 },
        { value: 66, label: '65岁以上' }
      ],
      startAge: '',
      endAge: '',
      options: [],
      genderquery: [],
      arr: [],
      index: 1,
      optionsbox: false,
      educationradio: '', // 学历选择 全部还是自定义 1 全部 2自定义
      educationarr: [
        {
          id: 'DOCTOR',
          name: '博士'
        }, {
          id: 'MASTER',
          name: '硕士'
        },
        {
          id: 'BACHELOR',
          name: '本科'
        },
        {
          id: 'SENIOR',
          name: '高中'
        },
        {
          id: 'JUNIOR',
          name: '初中'
        },
        {
          id: 'PRIMARY',
          name: '小学'
        },
        {
          id: 'JUNIOR_COLLEGE',
          name: '专科'
        }
      ], // 学历复选框数组
      checkedCities: [], // 选中学历数组集合
      systemradio: '', // 操作选择 全部还是自定义 1 全部 2自定义
      systemarr: [
        {
          id: 'IOS',
          name: 'iOS 系统'
        }, {
          id: 'ANDROID',
          name: '	Android 系统'
        }
      ],
      checkedsystem: [], // 选中操作系统数组
      phonepriceradio: '', // 手机价格 全部还是自定义 1 全部 2自定义
      phonepricearr: [
        {
          id: 'PRICE_1500_LESS',
          name: '￥ 1500 以下'
        }, {
          id: 'PRICE_1500_2500',
          name: '￥ 1500 ~ 2500'
        },
        {
          id: 'PRICE_2500_3500',
          name: '￥ 2500 ~ 3500'
        },
        {
          id: 'PRICE_3500_4500',
          name: '￥ 3500 ~ 4500'
        },
        {
          id: 'PRICE_4500_MORE',
          name: '￥ 4500 以上'
        }
      ],
      checkedphoneprice: [], // 选中手机价格数组,
      obj: {
        changregion: '', // 常驻地以及差旅绑定值
        startAgeitem: '', // 第一个年龄
        endAgeitem: '', // 第二个年龄
        allgender: '', // 性别
        positionSelectValue: [] // 地理位置选择数据
      }
    }
  },
  computed: {
    startAges() {
      return this.ageOptions.slice(1)
    },
    endAges() {
      if (!this.startAge) {
        return this.ageOptions
      }
      return this.ageOptions.filter(item => {
        return +item.value >= this.startAge
      })
    }
  },
  created() {
    // 地理位置请求
    this.fetchDirectionList()
    //  初始化地理位置
    if (this.ad_target.area_type === 'travel_area') {
      this.obj.positionSelectValue = this.resetLocation(this.ad_target.travel_area)
    }
    if (this.ad_target.area_type === 'area') {
      this.obj.positionSelectValue = this.resetLocation(this.ad_target.area)
    }
    // 常驻地以及差旅的初始化
    this.obj.changregion = this.ad_target.area_type
    this.obj.startAgeitem = Number(this.ad_target.age[0].split('~')[0])
    if (Number(this.ad_target.age[0].split('~')[1]) === 66) {
      this.obj.endAgeitem = 66
    } else {
      this.obj.endAgeitem = Number(this.ad_target.age[0].split('~')[1])
    }
    // 性别初始化
    if (this.ad_target.gender.length === 0) {
      // 全部
      this.obj.allgender = '1'
    } else {
      this.obj.allgender = this.ad_target.gender[0]
    }
    console.log('ad_target', this.ad_target)
    console.log('education', this.education.length)
    // 学历初始化
    if (this.education.length === 0) {
      this.educationradio = 1
    } else {
      this.checkedCities = this.education
      this.educationradio = 2
    }
    // 手机系统初始化
    if (this.user_os.length === 0) {
      this.systemradio = 1
    } else {
      this.checkedsystem = this.user_os
      this.systemradio = 2
    }
    // 手机价格初始化
    if (this.device_price.length === 0) {
      this.phonepriceradio = 1
    } else {
      this.checkedphoneprice = this.device_price
      this.phonepriceradio = 2
    }
    this.region = this.region1 === 'LIVE_IN' ? '1' : '2'
    if (this.gender1 === undefined) {
      this.gender = '10'
    }
    if (this.gender1 === 'MALE') {
      // 男
      this.gender = '1'
    }
    if (this.gender1 === 'FEMALE ') {
      // 女
      this.gender = '0'
    }
    // this.gender = this.gender1 === 'MALE' ? '1' : '0'
    this.startAge = this.startAge1
    this.endAge = this.endAge1
    this.getCouny()
  },
  methods: {
    // 获取省份城市列表
    fetchDirectionList() {
      directionList({ account_id: 21958829, type: 'REGION' }).then(res => {
        this.provinceSelectDataList = res.data
      })
    },
    // 数组去重
    unique(arr) {
      const resArr = []
      arr.forEach(item => {
        resArr.push(...item)
      })
      return [...new Set(resArr)]
    },
    // 还原地理位置数据格式
    resetLocation(data) {
      const locationArr = data
      const locationObj = {}
      const resArr = []
      locationArr.forEach(item => {
        const property = item.toString().slice(0, 2)
        if (!locationObj[property]) {
          locationObj[property] = []
        }
      })
      locationArr.forEach(item => {
        const res = item.toString().slice(0, 2)
        for (const property in locationObj) {
          if (property === res) {
            locationObj[property].push(item)
          }
        }
      })
      for (const value in locationObj) {
        const provinceNum = (value + '0000') * 1
        locationObj[value].forEach(item => {
          if (provinceNum !== item) {
            resArr.push([provinceNum, item])
          }
        })
      }
      return resArr
    },
    // 选择地理位置回传数据
    handle() {
      // console.log(this.unique(this.obj.positionSelectValue))
      this.$emit('Targetedpopulation', this.obj)
    },
    // 回传数据公共
    setdata() {
      this.$emit('setTargetedPopulation', {
        gender: JSON.parse(JSON.stringify(this.genderquery)),
        age: [{
          min: this.startAge,
          max: this.endAge
        }],
        geo_location: {
          location_types: [+this.region === 1 ? 'LIVE_IN' : 'VISITED_IN']
          // regions: JSON.parse(JSON.stringify(this.arr))
        },
        education: this.educationradio === 1 ? [] : JSON.parse(JSON.stringify(this.checkedCities)),
        user_os: this.systemradio === 1 ? [] : JSON.parse(JSON.stringify(this.checkedsystem)),
        device_price: this.phonepriceradio === 1 ? [] : JSON.parse(JSON.stringify(this.checkedphoneprice))
      })
    },
    // 获取省市区
    async getCouny() {
      const data = await getProvincialurbanareas({
        domestic: 1
      })

      this.data = data.data.list
      console.log('data', data.data.list)
    },
    // 选择年龄1
    startChange(value) {
      // this.startAge = value
      // this.setdata()
      this.$emit('Targetedpopulation', this.obj)
    },
    // 常驻地
    changeone(value) {
      // this.region = value
      // this.setdata()
      this.$emit('Targetedpopulation', this.obj)
    },
    // 选择年龄2
    endChange(value) {
      // console.log(value, this.obj.endAgeitem)
      this.$emit('Targetedpopulation', this.obj)
      // this.endAge = value
      // this.setdata()
    },
    // 选择性别
    menAndWomen(value) {
      this.$emit('Targetedpopulation', this.obj)
      // this.gender = value
      // if (this.gender === '1') {
      //   this.genderquery = ['MALE']
      // } else if (this.gender === '10') {
      //   this.genderquery = []
      // } else {
      //   this.genderquery = ['FEMALE']
      // }
      // this.setdata()
    },

    addressInputclick() {
      console.log('666')
      this.searchadress = !this.searchadress
    },
    handleCheckChange(data, checked) {
      console.log(checked.checkedKeys, checked.halfCheckedKeys, checked.checkedNodes, checked.halfCheckedNodes)
      console.log('this.$refs.tree.getCheckedNodes', data)

      const index = this.arr.findIndex(item => {
        return item.id === data.id
      })
      if (index === -1) {
        for (let i = 0; i < this.arr.length; i++) {
          for (let k = 0; k < checked.halfCheckedKeys.length; k++) {
            if (checked.halfCheckedKeys[k] === this.arr[i].id) {
              this.arr.splice(i, 1)
              console.log('this.arr', this.arr)
              console.log('进来')
              this.$emit('setTargetedPopulation', {
                gender: JSON.parse(JSON.stringify(this.genderquery)),
                age: [{
                  min: this.startAge,
                  max: this.endAge
                }],
                geo_location: {
                  location_types: [+this.region === 1 ? 'LIVE_IN' : 'VISITED_IN']
                },
                regions: JSON.parse(JSON.stringify(this.arr)),
                education: JSON.parse(JSON.stringify(this.checkedCities))
              })
              return
            }
          }
        }
        this.arr.push(data)
        console.log('this.arr2', this.arr)
        // if (this.arr.length !== 0) {
        //   console.log('777')
        //   console.log('checked.halfCheckedKeys', checked.halfCheckedKeys)
        //   for (let i = 0; i < this.arr.length; i++) {
        //     for (let k = 0; k < checked.halfCheckedKeys.length; k++) {
        //       if (checked.halfCheckedKeys[k] === this.arr[i].id) {
        //         // this.arr.splice(i, 1)
        //         console.log('进来')
        //       }

        //       if (checked.halfCheckedKeys[k] === []) {
        //         console.log('进来了777')
        //         // this.arr.push(data)
        //       }
        //     }
        //   }
        // } else {
        //   this.arr.push(data)
        //   console.log('888')
        // }

        // 不存在
      } else {
      // 存在
        this.arr.splice(index, 1)
        console.log('存在index', index)
      }
      this.$emit('setTargetedPopulation', {
        gender: JSON.parse(JSON.stringify(this.genderquery)),
        age: [{
          min: this.startAge,
          max: this.endAge
        }],
        geo_location: {
          location_types: [+this.region === 1 ? 'LIVE_IN' : 'VISITED_IN']
        },
        regions: JSON.parse(JSON.stringify(this.arr)),
        education: JSON.parse(JSON.stringify(this.checkedCities))
      })
      console.log('arr', JSON.parse(JSON.stringify(this.arr)))
      // console.log('this.handleNodeClick()', this.handleNodeClick())

      // console.log('this.$refs.tree.getCheckedKeys()', this.$refs.tree.getCheckedKeys())

      // const tree = this.$refs.tree
      // const array = tree.getCheckedKeys().concat(tree.getHalfCheckedKeys())
      // console.log(array)
      // checked.checkedKeys // 选中的节点id数组
      // checked.halfCheckedKeys // 半选中节点id数组
    },
    // 学历多选回调
    educationchange() {
      console.log('666')
      this.setdata()
    },
    // 选择学历 自定义 全部 的回调
    educallmethod() {
      if (this.educationradio === 1) {
        this.setdata()
      } else {
        this.setdata()
      }
    },
    systemmethod() {
      this.setdata()
    },
    systemchange() {
      this.setdata()
    },
    phonepricemethod() {
      this.setdata()
    },
    phonepricechange() {
      this.setdata()
    },
    handleNodeClick(v) {
      console.log('v', v)
    },
    sopew(data, data1) {
      console.log(data, data1)
    }

  }
}
</script>

<style scoped lang="less">
.targetedPopulation {
  width: 100%;
  padding: 0 0 32px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 4%), 0 0 0 1px hsl(0deg 0% 87% / 50%);
  margin-bottom: 12px;
  .targetedPopulation_titleArea {
    padding: 18px 24px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title_left {
      .title {
        margin-bottom: 2px;
        font-size: 14px;
        line-height: 24px;
        color: #1f1f1f;
        font-weight: 600;
      }
      .text {
        font-size: 12px;
      }
    }
    .title_right {
      display: flex;
      .button {
        outline: none;
        cursor: pointer;
        background-color: transparent;
        border: none;
        height: fit-content;
        padding: 7px 6px;
        border-radius: 4px;
        &:hover {
          color: #1f1f1f;
          background-color: rgba(168, 168, 168, 0.2);
        }
      }
    }
  }

  .targetedPopulation_main {
    padding: 0px 24px;
    display: flex;
    flex-direction: column;
    .main_item {
      display: flex;
      margin: 10px 0px;
      align-items: center;
      .item_title {
        width: 110px;
      }
      .item_main {
        .mian_box {
          display: flex;
          margin-bottom: 10px;
        }
      }
    }
  }
  .inputbox{
    width: 360px;
  }
  .inputboxr{
    position: relative;
  }
  .searchboxcss{
    position: absolute;
    min-width: 358px;
    top: 38px;
    left: 1px;
    max-height: 280px;
    z-index: 999;
    overflow: auto;
    background-color: pink;
  }
  .arrow_text{
    color: #1473CC;
    font-size: 10px;
    cursor: pointer;
  }
  .arrow::after{
    content: " ";
    display: inline-block;
    -webkit-transform: rotate(314deg);
    -ms-transform: rotate(314deg);
    transform: rotate(314deg);
    height: 8px;
    width: 8px;
    border-width: 0 0 2px 2px;
    border-color: #1473CC;
    border-style: solid;
    position: relative;
    top: -2px;
    left: 4px;
  }
  .two::after{
    -webkit-transform: rotate(134deg);
    -ms-transform: rotate(134deg);
    transform: rotate(134deg);
    top: 1px;
  }
  .title_box{
    width: 110px;
    display: inline-block;
    margin-top: 10px;
  }
  .group_box{
    margin-left: 110px;
    margin-top: 10px;
  }
  .choose_box{
    margin-bottom: 15px;
  }
}
</style>
